<template>
  <AprilBody :hide-stepper="true">
    <PopinMaintenance v-if="stepsData.family.maintenance_mode" />
    <div class="results-body">
      <div class="results-heading-container">
        <foundations-ui-wrapper>
          <div id="results-head" />
        </foundations-ui-wrapper>
      </div>

      <div class="results-content">
        <div
          class="bg-absolute"
          :style="{ height: bgAbsoluteHeight + 'px' }"
        ></div>
        <foundations-ui-wrapper>
          <NuxtPage />
        </foundations-ui-wrapper>
      </div>
    </div>
  </AprilBody>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import { type RootState } from '~/store/state'

export default defineNuxtComponent({
  name: 'LayoutResults',
  setup: () => {},
  computed: {
    ...(mapGetters({
      stepsData: 'prismic/stepsData',
    }) as {
      stepsData: () => RootState['prismic']['stepsData']
    }),
  },
  methods: {
    // append payload values to the cookie on commit
    onCommit(payload: ProjectPayload) {
      const cookie = this.$cookies('__april_project')
      let { value: cookieValue } = cookie

      Object.entries(payload).forEach(([key, value]) => {
        cookieValue = setValueInCookie(
          key as ProjectKey,
          value,
          cookieValue || ''
        )
      })

      cookie.value = cookieValue
    },
  },
  created() {
    // since component Nuxt does not trigger events emitted by sub-components, bind on Nuxt event
    // @see https://stackoverflow.com/a/67817642
    this.$bus.$on('commit-project', ($event: ProjectPayload) => {
      this.onCommit($event)
    })
  },
  beforeDestroy() {
    // removing eventBus listener
    this.$bus.$off('commit-project')
  },
})
</script>

<style lang="scss" scoped>
.results-body {
  min-height: calc(100vh - 291px);
  margin-bottom: april-rem(80);

  @media #{$mq-medium} {
    min-height: calc(100vh - april-rem(230));
    margin-bottom: april-rem(40);
  }

  .results-heading-container {
    background-color: $color-dark-blue;
    color: $color-white;
    padding: april-rem($spacing-l);

    @media #{$mq-medium} {
      padding: april-rem($spacing-2xl) 0;
    }
  }

  .results-content {
    overflow: hidden;
    position: relative;

    .bg-absolute {
      position: absolute;
      background-color: $color-dark-blue;
      @media #{$mq-mobile} {
        height: 430px;
      }
      height: 160px;
      @media #{$mq-medium} {
        height: 150px;
      }
      width: 100%;
      top: 0;
    }
  }
}
</style>
